// extracted by mini-css-extract-plugin
module.exports = {"emoji":"OX14Ew"};